// For full API documentation, including code examples, visit http://wix.to/94BuAAs
import wixWindow from 'wix-window';

$w.onReady(function () {
	let myLang = wixWindow.multilingual.currentLanguage; 

	if (myLang === 'sv') {
		$w('#statebox8').changeState('Svenska');
	}

  	if (myLang === 'en') {
		$w('#statebox8').changeState('English');
	}

	if (myLang === 'de') {
		$w('#statebox8').changeState('Deutch');
	}

	if (myLang === 'es') {
		$w('#statebox8').changeState('Espanol');
	}

	if (myLang === 'fr') {
		$w('#statebox8').changeState('Francais');
	}
});